import React, { useState } from "react";
import icon from '../assets/images/icona.png';
import {Col,Row,Container, Label} from "reactstrap";
import Form from "../components/Form";
import Section from "./Section";
import ServicesCardMain from "../components/ServicesCardMain";
import Preloader from "../components/Preloader";
import Navbar from '../Layout/Navbar';
import Footer from '../Layout/Footer';
import FooterAlt from '../Layout/FooterAlt';

const Ricambi = () =>{    
    const formLayout = {
        name:'ricambi',title:"Compila il form e ti risponderemo via mail",layout:[
            {fieldName:'nome',fieldDimensions:12,fieldLabel:'Nome e Cognome',fieldValidation:{required:true},fieldType:'text'},
            {fieldName:'email',fieldDimensions:6,fieldLabel:'Indirizzo email',fieldValidation:{required:true},fieldType:'email'},
            {fieldName:'telefono',fieldDimensions:6,fieldLabel:'Numero di telefono',fieldValidation:{required:true},fieldType:'number'},
            {fieldName:'messaggio',fieldDimensions:12,fieldLabel:'Messaggio',fieldValidation:{},fieldType:'textarea'},
        ]
    }    
    return ( <React.Fragment>
        <Preloader />
        <Navbar />
        <Section leftSide="Ricambi"/>
        <ServicesCardMain imgsrc={icon} title="Ricambi" caption="Disponiamo per chiunque lo necessiti, una vastissima gamma di ricambi  sia pronta consegna che su ordinazione." />
          <Form name={formLayout.name} title={formLayout.title} layout={formLayout.layout}></Form>
          <Footer />
          <FooterAlt />
          </React.Fragment>)
}

export default Ricambi;